import { Check, Crown } from "lucide-react";

const plans = [
  {
    id: "monthly",
    name: "Monthly Essentials",
    price: "$100",
    period: "/month",
    description: "The perfect entry point. One haircut and one shape-up per month to keep you looking sharp.",
    features: [
      "1 haircut per month",
      "1 shape-up per month",
      "Precision fade & lineup",
      "Hot towel finish",
      "Premium grooming products",
      "Flexible scheduling",
      "Same barber every visit",
    ],
    featured: false,
  },
  {
    id: "biweekly",
    name: "Bi-Weekly Pro",
    price: "$140",
    period: "/month",
    description: "Perfect for professionals who want to stay sharp with bi-weekly precision cuts.",
    features: [
      "Bi-weekly haircut (2x/month)",
      "Precision fade & lineup",
      "Beard trim & shape",
      "Hot towel finish",
      "Premium grooming products",
      "Flexible scheduling",
      "Same barber every visit",
    ],
    featured: false,
  },
  {
    id: "weekly",
    name: "Weekly Elite",
    price: "$250",
    period: "/month",
    description: "The ultimate plan for those who demand a fresh cut every single week.",
    features: [
      "Weekly haircut (4x/month)",
      "Precision fade & lineup",
      "Beard trim & shape",
      "Hot towel finish",
      "Premium grooming products",
      "Priority scheduling",
      "Same barber every visit",
      "Complimentary styling products",
      "Exclusive seasonal styles",
    ],
    featured: true,
  },
];

export default function MembershipPlans({ onSelect }) {
  return (
    <section data-testid="membership-section" className="relative py-24 md:py-32 bg-[#0A0A0B]">
      <div className="px-6 md:px-12 lg:px-24">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="h-px w-12 bg-[#C5A059]" />
            <span className="text-xs uppercase tracking-[0.2em] font-bold text-[#C5A059]">
              Membership Plans
            </span>
            <div className="h-px w-12 bg-[#C5A059]" />
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl tracking-tight font-medium text-[#F3F4F6] mb-4">
            Invest in yourself
          </h2>
          <p className="text-base text-[#A1A1AA] leading-relaxed font-light">
            Choose the plan that fits your lifestyle. All plans include full mobile service, premium products, and a dedicated barber.
          </p>
        </div>

        {/* Plans */}
        <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {plans.map((plan) => (
            <div
              key={plan.id}
              data-testid={`plan-${plan.id}`}
              className={`relative flex flex-col p-8 md:p-10 rounded-md transition-all duration-300 hover-lift ${
                plan.featured
                  ? "pricing-featured bg-[#141416] border border-[#C5A059]/30"
                  : "bg-[#141416] border border-white/5 hover:border-white/15"
              }`}
            >
              {plan.featured && (
                <div className="absolute -top-3 left-8 flex items-center gap-1.5 bg-[#C5A059] text-black text-xs font-bold uppercase tracking-wider px-4 py-1.5 rounded-sm">
                  <Crown className="w-3.5 h-3.5" />
                  Most Popular
                </div>
              )}

              <div className="mb-6">
                <h3 className="font-heading text-xl sm:text-2xl tracking-tight font-medium text-[#F3F4F6] mb-2">
                  {plan.name}
                </h3>
                <div className="flex items-baseline gap-1 mb-3">
                  <span className="font-heading text-4xl tracking-tighter font-medium text-[#F3F4F6]">
                    {plan.price}
                  </span>
                  <span className="text-[#71717A] text-sm">{plan.period}</span>
                </div>
                <p className="text-sm text-[#A1A1AA] leading-relaxed font-light">
                  {plan.description}
                </p>
              </div>

              <div className="flex-1 space-y-3 mb-8">
                {plan.features.map((feature, i) => (
                  <div key={i} className="flex items-center gap-3">
                    <Check className="w-4 h-4 text-[#C5A059] flex-shrink-0" />
                    <span className="text-sm text-[#A1A1AA]">{feature}</span>
                  </div>
                ))}
              </div>

              <button
                data-testid={`plan-select-${plan.id}`}
                onClick={() => onSelect && onSelect(plan.id)}
                className={`w-full font-medium transition-all duration-300 rounded-sm px-8 py-4 text-sm uppercase tracking-wider ${
                  plan.featured
                    ? "bg-[#C5A059] text-black hover:bg-[#D4AF37]"
                    : "bg-transparent border border-white/20 text-white hover:border-[#C5A059] hover:bg-white/5"
                }`}
              >
                Get Started
              </button>
            </div>
          ))}
        </div>

        {/* Trust note */}
        <p className="text-center text-xs text-[#71717A] mt-8">
          Cancel anytime. No contracts. No hidden fees.
        </p>
      </div>

      <div className="section-divider mt-24 mx-6 md:mx-12 lg:mx-24" />
    </section>
  );
}
